import React, { useEffect, useMemo, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import NavDropdownItem from "app/NavBar/components/NavDropdownItem";
import NavLinkItem from "app/NavBar/components/NavLinkItem";
import { NAV_ITEMS } from "app/NavBar/constants";
import {
  HRLight,
  Nav,
  TitleText,
  Ul,
} from "app/NavBar/index.style";
import { useMyAuth } from "shared/api/useMyProfile";
import { alertDialog } from "shared/ui/feedback";

// minAuth 이상만 볼 수 있는 항목(및 자식)을 권한 등급에 따라 걸러낸다.
// 자식이 모두 사라진 그룹도 숨긴다.
const filterNavByRole = (items, userAuth) =>
  items
    .filter((item) => (item.minAuth ?? 0) <= userAuth)
    .map((item) =>
      item.children
        ? {
            ...item,
            children: item.children.filter(
              (child) => (child.minAuth ?? 0) <= userAuth,
            ),
          }
        : item,
    )
    .filter((item) => !item.children || item.children.length > 0);

function NavBar() {
  const [openMenuKey, setOpenMenuKey] = useState(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const userAuth = useMyAuth();
  const navItems = useMemo(
    () => filterNavByRole(NAV_ITEMS, userAuth),
    [userAuth],
  );

  useEffect(() => {
    const admintoken = localStorage.getItem("admintoken");

    if (!admintoken) {
      alertDialog("로그인이 필요합니다.");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const activeDropdown = NAV_ITEMS.find(
      (item) =>
        item.children &&
        item.children.some((child) => pathname.startsWith(child.to)),
    );

    setOpenMenuKey(activeDropdown ? activeDropdown.key : null);
  }, [pathname]);

  const isItemActive = (item) => item.match(pathname);
  const isChildActive = (to) => pathname.startsWith(to);
  const toggleMenu = (menuKey) => {
    setOpenMenuKey((currentKey) => (currentKey === menuKey ? null : menuKey));
  };

  return (
    <Nav>
      <Ul>
        <li>
          <TitleText>한동대 총학생회 관리</TitleText>
        </li>
        <HRLight />
        {navItems.map((item) =>
          item.children ? (
            <NavDropdownItem
              key={item.key}
              item={item}
              isActive={isItemActive(item)}
              isOpen={openMenuKey === item.key}
              isChildActive={isChildActive}
              onToggle={() => toggleMenu(item.key)}
            />
          ) : (
            <NavLinkItem
              key={item.key}
              item={item}
              isActive={isItemActive(item)}
            />
          ),
        )}
      </Ul>
    </Nav>
  );
}

export default NavBar;
